/*!
 * Backbone.Subviews, v0.5
 * Copyright (c)2013 Rotunda Software, LLC.
 * Distributed under MIT license
 * http://github.com/rotundasoftware/backbone.subviews
*/

// Seriously altered by Bjorn. This is really a fork now.
// APM-ified by Bjorn.
// Altered Q1 2024 to use ES Modules, VAN-118309

import _ from 'lib/lodash.custom';
import Backbone from 'lib/backbone.courier';

var $ = Backbone.$;
var debugMode = false;

Backbone.Subviews = {};

Backbone.Subviews.add = function initializeSubviews(view) {
  var overriddenViewMethods = {
    render: view.render,
    remove: view.remove
  };

  // ****************** Overridden Backbone.View functions ******************

  view.render = function viewRender() {
    _prerender.call(this);
    var returnValue = overriddenViewMethods.render.apply(this, arguments);
    _postrender.call(this);

    return returnValue;
  };

  view.remove = function viewRemove() {
    if (this.subviews) {
      _.invoke(this.subviews, 'remove');
      this.subviews = {};
    }

    return overriddenViewMethods.remove.call(this);
  };

  // ****************** Private Utility Functions ******************

  function _prerender() {
    if (debugMode) {
      console.log(this);
      console.dirxml(this.el);
    }

    if (!this.subviews) this.subviews = {};

    _.each(this.subviews, function detachSubviews(thisSubview, subviewName) {
      thisSubview.$el.detach();
    });
  }

  function _postrender() {
    var _this = this;

    if (debugMode) {
      console.group('Subviews');
    }

    this.$("[data-subview]").each(function createSubviews() {
      var thisPlaceHolderDiv = $(this);

      var subviewName = thisPlaceHolderDiv.data('subview');
      var subviewIndex = parseInt(thisPlaceHolderDiv.data('subview-index'));
      var subviewId = thisPlaceHolderDiv.data('subview-id');

      var subviewCacheKey = thisPlaceHolderDiv.data('cache-key');
      var expectedSubviewKey = subviewName + (_.isNaN(subviewIndex) ? "" : subviewIndex) + (_.isUndefined(subviewId) ? "" : subviewId);
      var subviewKey = subviewCacheKey || expectedSubviewKey;

      var newSubview;
      // if the subview is already defined, then use the existing subview instead
      // of creating a new one. This allows us to re-render a parent view without
      // loosing any dynamic state data on the existing subview objects.

      // NOTE: due to NGP VAN customizations, the subview will almost never be cached under the key checked here
      // Instead, it will use a value determined by the newly created view
      // Caching tech debt here to be addressed in VAN-71872
      if (_.isUndefined(_this.subviews[subviewKey])) {
        var subviewCreator = _this.subviewCreators[subviewName];

        if (_.isUndefined(subviewCreator)) return;

        if (debugMode) {
          console.log("Creating " + subviewName.replace(/^NVForm_(.+)_view(\d{1,2}(c\d{1,2})?)?$/, '$1'));
        }

        newSubview = subviewCreator.call(_this, subviewIndex, subviewId);

        // If there is no explicit cache key, add to the subview dictionary based on the definition
        if (!subviewCacheKey) {
          if (newSubview.options.definition) {
            subviewKey = newSubview.options.definition.name || subviewKey;
          } else if (newSubview.options.form_definition) {
            subviewKey = newSubview.options.form_definition.type || subviewKey;
          }
        }

        newSubview.parent = _this;

        _this.subviews[subviewKey] = newSubview;
      } else {
        newSubview = _this.subviews[subviewKey];
      }

      newSubview.$el.data({
        'formview': newSubview.options.formview,
        'parent': _this,
        'view': newSubview,
        'definition': newSubview.options.definition,
        'index': subviewIndex,
        'options': _.omit(newSubview.options, 'formview', 'templates', 'parent')
      });

      thisPlaceHolderDiv.replaceWith(newSubview.$el);
    });



    _.each(this.subviews, function renderSubviews(thisSubview, subviewName) {
      if (debugMode) console.groupCollapsed("Rendering " + subviewName.replace(/^NVForm_(.+)_view(\d{1,2}(c\d{1,2})?)?$/, '$1'));
      thisSubview.render();
      if (debugMode) {
        console.dirxml(thisSubview.el);
        console.groupEnd();
      }
    });

    if (_.isFunction(this._onSubviewsRendered)) this._onSubviewsRendered.call(this);

    if (debugMode) console.groupEnd(); // "Rendering view"
  }
};

export default Backbone;
